export default __webpack_public_path__ + "static/media/beatwave.3c90b107.png";